import React from 'react';
import { useSellviaCleanupJob } from '../../../context/SellviaCleanupJobContext';

// Sits right below MainNav (same slot pattern as BulkJobBanner) — shows
// while a Sellvia order-cleanup run (Manual batch or an Auto tick) is
// actively in progress, then closes itself automatically once it's done.
const SellviaCleanupBanner = () => {
    const ctx = useSellviaCleanupJob();
    const job = ctx?.job;
    if (!job || job.status !== 'running') return null;

    const pct = job.total > 0 ? Math.round((job.current / job.total) * 100) : 0;
    const label = job.type === 'auto' ? 'Auto cleanup' : 'Manual cleanup';

    return (
        <div style={{
            position: 'sticky', top: 'var(--MainNav-height, 56px)', zIndex: 998,
            background: 'linear-gradient(90deg, #6f5212 0%, #8c6a1c 55%, #b8892c 100%)', color: '#fff', padding: '10px 24px',
            display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 4px 16px rgba(111,82,18,0.35)',
            flexWrap: 'wrap',
        }}>
            <style>{`@keyframes ms-cleanup-spin { to { transform: rotate(360deg); } }`}</style>
            <span style={{ width: 16, height: 16, border: '2px solid #f3d58a', borderTopColor: '#fff', borderRadius: '50%', display: 'inline-block', animation: 'ms-cleanup-spin 0.7s linear infinite', flexShrink: 0 }} />
            <span style={{ fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap' }}>
                {label}: {job.current}/{job.total}
            </span>
            <span style={{ fontSize: 12, color: '#f6e9cc', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 320 }}>
                {job.status_message || ''}
            </span>
            <div style={{ flex: 1, background: 'rgba(255,255,255,0.22)', borderRadius: 4, height: 6, minWidth: 80 }}>
                <div style={{ width: `${pct}%`, height: '100%', background: '#f3d58a', borderRadius: 4, transition: 'width 0.2s' }} />
            </div>
            <span style={{ fontSize: 12, color: '#f3d58a', whiteSpace: 'nowrap' }}>
                ✅ {job.success}{job.failed > 0 ? ` ❌ ${job.failed}` : ''}
            </span>
            <button
                onClick={ctx.cancelJob}
                style={{ padding: '5px 14px', background: '#dc2626', border: 'none', borderRadius: 7, color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
                ✕ Cancel
            </button>
        </div>
    );
};

export default SellviaCleanupBanner;
